/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import AWSAppSyncClient from 'aws-appsync';
import { DocumentNode } from 'graphql';
import { gql } from 'graphql-tag';
import { filter, map } from 'rxjs/operators';
import {
  ConnexTAPIRes,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';
import { isNotNullOrUndefined } from '../../utils';

export interface OnConnextAPIInput {
  deviceId?: string;
}
const build = (_query: DocumentNode, input: OnConnextAPIInput, name = 'QueryResult') => {
  const bQuery = `
  subscription ${ name }(`+
    ( input.deviceId !== undefined ? `$deviceId: String = ${JSON.stringify(input.deviceId).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    onConnextAPI(
      ${ input.deviceId !== undefined ? 'deviceId: $deviceId,' : '' }
    ){
      ...connextapires
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class OnConnextAPISubscription {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment connextapires on ConnexTAPIRes { ... }
   */
  execute(_query: DocumentNode, input: OnConnextAPIInput) {
    return this.graphqlClient$.pipe(
      isNotNullOrUndefined(),
      map((client: AWSAppSyncClient<any>) =>
        client.subscribe<{ data : {  onConnextAPI : Partial<ConnexTAPIRes>} }>({ query: build(_query, input) }),
      ),
    );
  }
}
